const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const form = require('../../../deploynaut/js/Form.jsx');

const RollbarForm = createReactClass({
	getInitialState: function() {
		var state = {
			id: null,
			accessToken: ""
		};

		var integration = this.props.integration;
		if (integration && integration.options !== undefined) {
			state.id = integration.id;
			state.accessToken = integration.options.AccessToken;
		}

		return state;
	},

	render() {
		console.log(this.props);
		return (
			<div className="integration-form">
				<p>
					Enabling the <a href='https://rollbar.com' target="_new">Rollbar</a> integration will notify Rollbar of your
					deployments to link suspect deployments with recent errors
				</p>

				<form.Form
					ref="rollbarForm"
					url={this.props.model.UpdateURL}
					securityID={this.props.model.InitialSecurityID}
					buttonTitle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.afterSuccess}
				>
					<div className="form-group">
						<label htmlFor="AccessToken">Access Token</label>
						<form.Input
							name="AccessToken"
							required
							validationError="Please enter a valid Access Token belonging to your project"
							placeholder="Access Token"
							value={this.state.accessToken}
						/>
					</div>

					<form.Hidden name="Type" value="Rollbar" />
					<form.Hidden name="ID" value={this.state.id} />
				</form.Form>
			</div>
		);
	}
});

module.exports = RollbarForm;
